import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { useHttpClient } from '@bonusly/http-client';

import { RecognizeResponse } from '../types/api';
import { BonusReport, BonusReportReason } from '../types/bonus-report';
import { toSnakeCaseKeys } from '../utils/object';
import { ResourcePath } from './resource-path';
import { MutationOptions } from './types';

export interface BonusReportCreateArgs {
	bonusReport: {
		bonusId: string;
		reason: BonusReportReason;
		userInput: string;
	};
}

export type BonusReportCreateResponseData = RecognizeResponse<BonusReport>;

export type BonusReportCreateResponse = AxiosResponse<BonusReportCreateResponseData>;

export const useCreateBonusReport = (options: MutationOptions<BonusReportCreateArgs, BonusReportCreateResponse>) => {
	const http = useHttpClient('v2');
	return useMutation(
		(options: BonusReportCreateArgs) =>
			http.post<BonusReportCreateResponseData, BonusReportCreateResponse>(ResourcePath.BonusReports, toSnakeCaseKeys({ bonusReport: options.bonusReport })),
		options
	);
};
